export default {
	field: 'name',
	name: 'Name',
}
